import axios from "axios"
import { API_BASE_URL, config } from "../../../config/apiConfig"

const createOrder = async (orderData) => {
    const response = await axios.post(`${API_BASE_URL}/order/`, orderData, config)
    if (response.data) {
        return response.data
    }
}


export const orderService = {
    createOrder,
}
